import type { FC } from 'react';
import { useLocation } from 'react-router';
import type { ActiveSection } from 'src/components/layout/header/types';
import { ExternalLink, Link } from 'src/components/navigation/link';
import { useOptionalAuthenticatedMonolithUser } from 'src/hooks/use-monolith-user';
import { useSystemInfo } from 'src/hooks/use-system-info';

export const SecondaryNavTransport: FC<{
  activeSection: ActiveSection;
}> = ({ activeSection }) => {
  const { pathname, hash } = useLocation();
  const monolithUser = useOptionalAuthenticatedMonolithUser();
  const systemInfo = useSystemInfo();

  if (!activeSection.transport) return null;
  if (monolithUser?.isSso) return null;

  return (
    <div
      className={`
        flex flex-col flex-wrap items-stretch gap-x-xl gap-y-md
        md:flex-row md:items-center
        legacy:gap-x-[2rem] legacy:gap-y-[1rem]
      `}
      data-testid="secondary-nav"
    >
      <Link
        mode="secondary"
        to="/transport/auctions"
        isActive={
          (pathname.startsWith('/platform') && hash.startsWith('#/auctions')) ||
          pathname.startsWith('/transport/auctions') ||
          pathname.startsWith('/snam-bidding') ||
          pathname.startsWith('/modulation-service-auctions')
        }
      >
        Auctions
      </Link>

      {monolithUser?.isTso ? (
        <>
          <Link mode="secondary" to="/transport/fcfs-booking">
            FCFS Booking
          </Link>

          <Link
            mode="secondary"
            to="/transport/secondary"
            isActive={
              (pathname.startsWith('/platform') &&
                (hash.startsWith('#/create-external-trade') ||
                  hash.startsWith('#/edit-proposal') ||
                  hash.startsWith('#/create-proposal'))) ||
              pathname.startsWith('/transport/secondary')
            }
          >
            Secondary Trading
          </Link>

          <Link
            mode="secondary"
            to="/transport/network-points"
            isActive={
              (pathname.startsWith('/platform') &&
                hash.startsWith('#/network-point') &&
                !hash.startsWith('#/network-point/bundle')) ||
              pathname.startsWith('/transport/network-points')
            }
          >
            Network Points
          </Link>

          <Link
            mode="secondary"
            to="/transport/bundle-requests"
            isActive={
              (pathname.startsWith('/platform') &&
                hash.startsWith('#/network-point/bundle')) ||
              pathname.startsWith('/transport/bundle-requests')
            }
          >
            Bundle Requests
          </Link>
        </>
      ) : (
        <>
          <Link mode="secondary" to="/transport/fcfs-booking">
            FCFS Booking
          </Link>

          {systemInfo.featureMultiYearCapacity && (
            <ExternalLink
              mode="secondary"
              href={`${PRISMA_CONFIG.angularUrl}/#/multi-year-auctions`}
            >
              Multi-Year Capacity
            </ExternalLink>
          )}

          <Link
            mode="secondary"
            to="/transport/secondary"
            isActive={
              (pathname.startsWith('/platform') &&
                (hash.startsWith('#/create-external-trade') ||
                  hash.startsWith('#/edit-proposal') ||
                  hash.startsWith('#/create-proposal'))) ||
              pathname.startsWith('/transport/secondary')
            }
            data-help-annotation="secondary-trading:2"
          >
            Secondary Trading
          </Link>

          <Link
            mode="secondary"
            to="/transport/network-points"
            isActive={
              (pathname.startsWith('/platform') &&
                hash.startsWith('#/network-point')) ||
              pathname.startsWith('/transport/network-points')
            }
          >
            Network Points
          </Link>
        </>
      )}
    </div>
  );
};
